const lelang = {
  namespaced: true,

  state: {
    kbliDisplay: '',
    paket: null,
    jadwal: [],
    peserta: false,
    undangan: false,
  },

  getters: {
    kbliDisplay: state => state.kbliDisplay,
    paket: state => state.paket,
    jadwal: state => state.jadwal,
    peserta: state => state.peserta,
    undangan: state => state.undangan,
  },

  mutations: {
    setKBLIDisplay: function(state, val) {
      state.kbliDisplay = val
    },
    setPaket: function(state, val) {
      state.paket = val
    },
    setJadwal: function(state, val) {
      state.jadwal = val
    },
    setPeserta: function(state, val) {
      state.peserta = val
    },
    setUndangan: function(state, val) {
      state.undangan = val
    },
  },

  actions: {
    assignKBLIDisplay: function(context, val) {
      context.commit('setKBLIDisplay', val)
    },
    assignPaket: function(context, val) {
      context.commit('setPaket', val)
    },
    assignJadwal: function(context, val) {
      context.commit('setJadwal', val)
    },
    assignPeserta: function(context, val) {
      context.commit('setPeserta', val)
    },
    assignUndangan: function(context, val) {
      context.commit('setUndangan', val)
    },
  }
}

export default lelang